export default __webpack_public_path__ + "static/media/arrow-repeat-gray.82448d35.svg";